import type {ArenaProp} from './arena.ts';

/** Visual damage stages use the same thresholds on every client. */
export function destructionStage(hp:number,maxHp:number,gone=false):0|1|2|3 {
  if(gone)return 3;
  if(maxHp<=0 || hp/maxHp>2/3)return 0;
  return hp/maxHp>1/3?1:2;
}

/** The falling statue hits a capsule drawn on the ground during its warning. */
export function inCollapseArea(prop:ArenaProp,x:number,y:number,z:number):boolean {
  const c=prop.collapse;if(!c || y<prop.y-.8 || y>prop.y+1.4)return false;
  const length=Math.hypot(c.dx,c.dz);
  if(length===0)return false;
  const dx=c.dx/length,dz=c.dz/length;
  const along=Math.max(0,Math.min(c.length,(x-prop.x)*dx+(z-prop.z)*dz));
  return Math.hypot(x-prop.x-dx*along,z-prop.z-dz*along)<=c.width/2+.35;
}
